import React, { useState } from 'react';
import Input from '@mui/joy/Input'; // Import Input instead of Textarea
import IconButton from '@mui/joy/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye,faEyeSlash} from '@fortawesome/free-solid-svg-icons';// Eye off icon for hiding password

const inputStyles = {
  wrapper: {
    position: 'relative',
    width: '100%',
    marginBottom: '1rem',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: '2px solid #e2e8f0',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    '&:focus': {
      borderColor: '#2563eb',
      boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.1)',
      outline: 'none',
    },
    '&:hover': {
      borderColor: '#94a3b8',
    },
    '&::placeholder': {
      color: '#94a3b8',
    }
  },
  label: {
    position: 'absolute',
    top: '-0.5rem',
    left: '0.75rem',
    padding: '0 0.25rem',
    backgroundColor: '#ffffff',
    fontSize: '0.75rem',
    color: '#64748b',
    transition: 'all 0.2s ease',
  }
}

export default function TextInput({
  type,
  label,
  value,
  setValue,
  icon,
  required,
  readOnly,
}) {
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  // Toggle password visibility when icon is clicked
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Input
      type={type === 'password' && !showPassword ? 'password' : 'text'} // Toggle between password and text
      label={label}
      variant="outlined"
      fullWidth
      size="lg"
      placeholder={label}
      sx={{
        height: '56px',
        marginBottom: 2,
        borderRadius: '12px',
        fontSize: '16px',
      }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required={required}
      readOnly={readOnly}
      startDecorator={icon || null} // Use the icon directly in startDecorator
      endDecorator={
        type === 'password' && (
          <IconButton
            onClick={togglePasswordVisibility}
            edge="end"
            sx={{ borderRadius:"50%" ,mr:"0px" }}
          >
            {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
          </IconButton>
        )
      }
    />
  );
}
